import React from "react";
import FormSummaryLayout from "./FormSummaryLayout";
import { useSignupContext } from "../../../context/SignupContext";
import { useAppContext } from "../../../context/AppContext";
import SubscriptionDetail from "./SubscriptionDetail";
import SubscriptionTotal from "./SubscriotionTotal";
import SummaryPanelErrorBoundary from "./SummaryPanelErrorBoundary";
import { fetchCart } from "../../../api/cartAPI.js";
import { Spin } from "antd";

const SummaryContainer = props => {
    const {
        state: { errors },
    } = useSignupContext();

    const {
        state: { cart, loading },
        dispatch,
    } = useAppContext();

    const { showCoupon } = props;

    const { items = [], total = 0, billingPeriod = 1, tax = 0, discount = 0, subtotal = 0 } = cart || {};
    return (
        <FormSummaryLayout>
            <SummaryPanelErrorBoundary
                {...{
                    cart,
                    errors,
                    retry: () => fetchCart(dispatch),
                }}
            >
                <Spin spinning={loading > 0}>
                    {items &&
                        items.map((item, key) => {
                            return (
                                item && (
                                    <SubscriptionDetail
                                        key={key}
                                        itemDetails={item}
                                        showCoupon={showCoupon}
                                    />
                                )
                            );
                        })}
                    <SubscriptionTotal
                        subtotal={subtotal}
                        discount={discount}
                        tax={tax}
                        total={total}
                        billingPeriod={billingPeriod}
                    />
                </Spin>
            </SummaryPanelErrorBoundary>
        </FormSummaryLayout>
    );
};

export default SummaryContainer;
